import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { CustomizationModalProps } from './types';

export const customizationModalEntryPoint: EntryPoint<
	EntryPointComponent<{}, {}, CustomizationModalProps, {}>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-navigation-global-side-navigation-customization-modal" */ './index'
			),
		{
			moduleId: 'navigation.global-side-navigation.customization-modal',
		},
	),
	getPreloadProps: () => ({}),
});
